export const OneKycEvents = {
  GetOrigin: "GET_ORIGIN_FROM_ONEKYC",
  SendOrigin: "SEND_ORIGIN_TO_ONEKYC",
  Callback: "ONEKYC_QR_CALLBACK",
};

export const OneKycParams = {
  Status: "status",
  PartnerSessionId: "partner_session_id",
  ErrorCode: "error_code",
};
